import styled from '@emotion/styled'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Headbar from '../../components/common/HeadBar'
import Tabs from '../../components/common/Tabs'
import colors from '../../constant/colors'
import * as paths from '../../constant/path'
import { useGetMaternityHistoryList } from '../../services/maternity/maternity-query'
import { UserClaimList, EClaimHistory as EClaimHistoryType, EClaimStatus } from '../../services/e-claim/e-claim-types'
import { useScreen } from '../../utils/responsive-helper'
import { MaternityHistoryCard } from './component'

const Layout = styled.div`
  margin-bottom: 40px;
`
const ContentLayout = styled.div`
  background-color: ${colors.WHITE};
  padding: 16px;
  border-radius: 16px;
  min-height: 500px;
`
const MaternityCardLayout = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`

type MaternityHistoryPageProps = {
  data: EClaimHistoryType
}
const MaternityHistoryPage = (props: Partial<MaternityHistoryPageProps>) => {
  const { data } = props

  return (
    <MaternityCardLayout>
      {data?.userClaimList?.map((item: UserClaimList) => (
        <Link
          key={item.claimId}
          to={paths.maternityHistoryDetail({ routeParam: { id: item.id } })}
        >
          <MaternityHistoryCard data={item} status={data?.statusName} />
        </Link>
      ))}
    </MaternityCardLayout>
  )
}

const MaternityHistory = () => {
  const { isMobile } = useScreen()
  const { t } = useTranslation()
  const { data: MaternityHistoryList, isLoading } = useGetMaternityHistoryList()

  const dataSource = useMemo(() => {
    return [
      {
        name: t('eClaim.history.status.pending'),
        key: '0',
        page: <MaternityHistoryPage data={MaternityHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.UNAPPROVED)[0]} />,
      },
      {
        name: t('eClaim.history.status.cancel'),
        key: '1',
        page: <MaternityHistoryPage data={MaternityHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.CANCELED)[0]} />,
      },
      {
        name: t('eClaim.history.status.rejected'),
        key: '2',
        page: <MaternityHistoryPage data={MaternityHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.REJECTED)[0]} />,
      },
      {
        name: t('eClaim.history.status.approved'),
        key: '3',
        page: <MaternityHistoryPage data={MaternityHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.APPROVED)[0]} />,
      },
    ]
  }, [MaternityHistoryList])

  return (
    <>
      <Layout style={{ paddingTop: '24px' }}>
        <Headbar title={t('eClaim.history.title')} backWard={paths.maternity()} titleColor={colors.BLACK} />
        <ContentLayout>
          <Tabs
            dataSource={dataSource}
            mode={isMobile ? 'select' : undefined}
          />
        </ContentLayout>
      </Layout>
    </>
  )
}
export default MaternityHistory
